import request from '@/utils/request';

export function fetchList(query) {
    return request({
        url: 'https://viaglobal.pl/api//candidates',
        method: 'get',
        params: query,
    });
}

export function fetchCandidate(id) {
    return request({
        url: 'https://viaglobal.pl/api//candidates/' + id,
        method: 'get',
    });
}

export function fetchPv(id) {
    return request({
        url: 'https://viaglobal.pl/api//candidates/' + id + '/pageviews',
        method: 'get',
    });
}

export function createCandidate(data) {
    return request({
        url: 'https://viaglobal.pl/api//candidates',
        method: 'post',
        data,
    });
}

export function updateCandidate(data) {
    return request({
        url: 'https://viaglobal.pl/api//candidates/' + data.id,
        method: 'put',
        data,
    });
}

export function deleteCandidate(data) {
    return request({
        url: 'https://viaglobal.pl/api//candidates/' + data.id,
        method: 'delete',
        data,
    });
}

export function sendMessage(data) {
    return request({
        url: 'https://viaglobal.pl/api//actualization/message',
        method: 'post',
        data,
    });
}
